import React, { useRef, useImperativeHandle, forwardRef } from "react";
import html2pdf from "html2pdf.js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PrintToPDF = forwardRef(({ tableComponent, header }, ref) => {
  const contentRef = useRef();

  useImperativeHandle(ref, () => ({
    generatePDF: () => {
      if (contentRef.current) {
        html2pdf()
          .from(contentRef.current)
          .set({
            margin: 0.5,
            filename: "Drawing_BOM.pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "a2", orientation: "landscape" },
          })
          .save();
      }
    },
  }));

  return (
    <div style={{ display: "none" }}>
      <div ref={contentRef}>
        <Box sx={{ p: 2, fontSize: 12, width: "100%" }}>
          <Typography variant="h5" align="center" gutterBottom>
            {header}
          </Typography>
          {tableComponent}
        </Box>
      </div>
    </div>
  );
});

export default PrintToPDF;
